import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { useToggle } from '@/hooks/useToggle';
import ChartSkeleton from '@/components/ChartSkeleton';
import { classes, styles } from './utils';

export type ChartFrameProps = {
  isFetchingData?: boolean;
  showBars?: boolean;
  className?: string;
  categories?: readonly string[];
  height?: number;
  children: (onMount: () => void) => ReactNode;
};

export default function ChartFrame({
  isFetchingData,
  showBars,
  className,
  categories,
  height,
  children,
}: ChartFrameProps) {
  const [isChartMounted, toggleChartMounted] = useToggle(false);

  const isChartVisible = isChartMounted && !isFetchingData;

  return (
    <div
      style={styles.frame(height)}
      className={twMerge(classes.frame, className)}>
      {!isChartVisible && (
        <div className={classes.layer}>
          <ChartSkeleton showBars={showBars} categories={categories} />
        </div>
      )}
      {!isFetchingData && (
        <div
          className={twMerge(classes.chart, !isChartMounted && classes.hidden)}>
          {children(() => toggleChartMounted(true))}
        </div>
      )}
    </div>
  );
}
